"use client";

import { memo } from "react";
import type { ServicesLanguagesProps } from "./types";
import { servicesLanguagesMap } from "./constants";
import {
  LanguagesSection,
} from "@/components/screen/global-components/language";

const ServicesLanguages = ({
  variant = "certified",
  className,
}: ServicesLanguagesProps) => {
  return (
    <LanguagesSection
      className={className}
      {...servicesLanguagesMap[variant]}
    />
  );
};

export default memo(ServicesLanguages);
